import { Route } from 'vue-router';

/**
 * Ponte entre o funil do ProUni e a matrícula comum.
 *
 * O aluno aprovado no ProUni entra na matrícula por um link pessoal
 * (`/?cupom=PROUNI-XXXXXXXX`). O cupom é **identificador, não credencial**:
 * quem autentica é a sessão Pocket (cookie `d`), a mesma conta com que ele fez
 * a inscrição. Vazar o cupom não abre nada.
 *
 * Fica em `helpers/` porque é lido pelos dois lados da ponte — o bootstrap da
 * matrícula (`App.vue`) e a trava de curso/polo (`ChangeCourseCampus.vue`) —
 * sem que um pipeline importe o outro.
 */
export const PROUNI_VOUCHER_PREFIX = 'PROUNI-';

/** Nome do query param do link enviado por e-mail ao aluno. */
export const PROUNI_VOUCHER_QUERY_PARAM = 'cupom';

export const isProuniVoucher = (code?: string | null): boolean =>
  typeof code === 'string' &&
  code
    .trim()
    .toUpperCase()
    .startsWith(PROUNI_VOUCHER_PREFIX);

/**
 * Lê o cupom do link. Retorna `undefined` quando o param não existe ou está
 * vazio — é esse `undefined` que garante que a matrícula comum siga idêntica.
 */
export const getProuniVoucherFromRoute = (route?: Route | null): string | undefined => {
  const raw = route?.query?.[PROUNI_VOUCHER_QUERY_PARAM];
  const value = Array.isArray(raw) ? raw[0] : raw;

  if (typeof value !== 'string') return undefined;

  const voucher = value.trim();
  return voucher || undefined;
};
